/* eslint-disable max-len */
/* eslint-disable eqeqeq */
import React from 'react';
import Helpers from '../helpers';

import { ProductFormContext } from '../../../context/product-form-context';

export default function OptionGroupAsRadio({
	option,
	index: groupIndex,
	setFilter,
	filters,
}) {
	const {
		availabilityMap,
		product,
		showErrors,
	} = React.useContext(ProductFormContext);

	const allOptionValues =	option.values;
	const availableOptionValues = Helpers.getAvailableOptionsWithinSelections(
		product,
		groupIndex,
		filters,
		availabilityMap
	);

	//	----------
	//	Pre-select OptionGroups containing only one 'available' option (which is based on 'filters' have already been applied)
	//	----------
	const thisOptionGroupAlreadyHasAFilter = !!filters[groupIndex];
	if (!thisOptionGroupAlreadyHasAFilter && availableOptionValues?.length === 1) {
		// console.log(group_index,available_option_values[0]);	//	Debugging Only
		setFilter(groupIndex, availableOptionValues[0]);
	}

	function handleClick(event) {
		const selectElement = event.target;
		const selected = filters[groupIndex] === selectElement.value;
		setFilter(groupIndex, selected ? null : selectElement.value);
	}

	//	---------------
	//	Render Children
	//	---------------
	const options = allOptionValues.map((_v, i) => {
		//	Don't render this option at all if it's not available.
		// if (!available) return null;

		return (
		// eslint-disable-next-line
			<label key={i}>
				<input
					type={'radio'}
					onChange={handleClick}
					checked={filters[groupIndex] == _v}
					// eslint-disable-next-line
					key={i}
					value={_v}
				/>
				<svg width={'13'} height={'9'} viewBox={'0 0 13 9'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
					<path d={'M1 4L5 8L11.5 1.5'} stroke={'white'} strokeWidth={'1.5'} strokeLinecap={'round'} strokeLinejoin={'round'} />
				</svg>
				{_v}
			</label>
		);
	});

	const selectedLabel	= filters[groupIndex];

	//	Don't render anything if there are no options
	const isOptionFormat = option.name.toLowerCase() == 'format';
	if (!availableOptionValues.length && !isOptionFormat)	return null;

	return (
		<div className={`pdp-form__option-group pdp-form__option-group--radio ${ !selectedLabel && showErrors ? 'error' : '' }`}>
			<div className={`pdp-form__option-group-label`}>
				{ `${ option.name }:` }
			</div>
			<div className={'radio'}>
				{options}
			</div>
			{!selectedLabel && showErrors && (
				<div className={`pdp-form__option-group-error`}>
					{`Please select a ${ option.name === 'Format' ? 'type' : option.name.toLowerCase() }`}
				</div>
			)}
			{/* <span className={'active_selection'}>{selectedLabel ?? `Please select a ${ option.name.toLowerCase() }`}</span> */}
		</div>
	);
}// function
